var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.modalShown,
          expression: "modalShown"
        },
        {
          name: "drag",
          rawName: "v-drag",
          value: { handle: "#modal-moving" },
          expression: "{handle:'#modal-moving'}"
        }
      ],
      staticClass: "modal",
      staticStyle: { position: "fixed" },
      attrs: { id: "bom-custom-config-modal" }
    },
    [
      _c("div", { staticClass: "modal-main" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "data-area" }, [
          _c("div", { staticClass: "error_message" }, [
            _vm._v(_vm._s(_vm.errorMessage.text))
          ]),
          _vm._v(" "),
          _c(
            "ul",
            _vm._l(10, function(num, index) {
              return _c("li", { key: index }, [
                _c("span", { staticClass: "label" }, [
                  _vm._v("カスタム名" + _vm._s(num))
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.customNameGroup[num],
                      expression: "customNameGroup[num]"
                    }
                  ],
                  attrs: { type: "text" },
                  domProps: { value: _vm.customNameGroup[num] },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.customNameGroup, num, $event.target.value)
                    }
                  }
                })
              ])
            })
          )
        ]),
        _vm._v(" "),
        _vm.validateErrorMessages &&
        Object.keys(_vm.validateErrorMessages).length > 0
          ? _c("p", { staticClass: "error_message" }, [
              _vm._v(_vm._s(_vm.validateErrorMessages["bomCustomName1"]))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.validateErrorMessages &&
        Object.keys(_vm.validateErrorMessages).length > 0
          ? _c("p", { staticClass: "error_message" }, [
              _vm._v(_vm._s(_vm.validateErrorMessages["bomCustomName2"]))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.validateErrorMessages &&
        Object.keys(_vm.validateErrorMessages).length > 0
          ? _c("p", { staticClass: "error_message" }, [
              _vm._v(_vm._s(_vm.validateErrorMessages["bomCustomName3"]))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.validateErrorMessages &&
        Object.keys(_vm.validateErrorMessages).length > 0
          ? _c("p", { staticClass: "error_message" }, [
              _vm._v(_vm._s(_vm.validateErrorMessages["bomCustomName4"]))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.validateErrorMessages &&
        Object.keys(_vm.validateErrorMessages).length > 0
          ? _c("p", { staticClass: "error_message" }, [
              _vm._v(_vm._s(_vm.validateErrorMessages["bomCustomName5"]))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.validateErrorMessages &&
        Object.keys(_vm.validateErrorMessages).length > 0
          ? _c("p", { staticClass: "error_message" }, [
              _vm._v(_vm._s(_vm.validateErrorMessages["bomCustomName6"]))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.validateErrorMessages &&
        Object.keys(_vm.validateErrorMessages).length > 0
          ? _c("p", { staticClass: "error_message" }, [
              _vm._v(_vm._s(_vm.validateErrorMessages["bomCustomName7"]))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.validateErrorMessages &&
        Object.keys(_vm.validateErrorMessages).length > 0
          ? _c("p", { staticClass: "error_message" }, [
              _vm._v(_vm._s(_vm.validateErrorMessages["bomCustomName8"]))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.validateErrorMessages &&
        Object.keys(_vm.validateErrorMessages).length > 0
          ? _c("p", { staticClass: "error_message" }, [
              _vm._v(_vm._s(_vm.validateErrorMessages["bomCustomName9"]))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.validateErrorMessages &&
        Object.keys(_vm.validateErrorMessages).length > 0
          ? _c("p", { staticClass: "error_message" }, [
              _vm._v(_vm._s(_vm.validateErrorMessages["bomCustomName10"]))
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "button-area" }, [
          _c(
            "button",
            {
              staticClass: "main_btn",
              attrs: { type: "button" },
              on: { click: _vm.updateBomCustom }
            },
            [_vm._v("OK")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "main_btn",
              attrs: { type: "button" },
              on: { click: _vm.onCancel }
            },
            [_vm._v("キャンセル")]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "title-area", attrs: { id: "modal-moving" } },
      [_c("h2", [_vm._v("構成明細カスタム設定")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-402eb90e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-402eb90e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/components/common/BomCustomConfigModal.vue
// module id = null
// module chunks = 